import { queryOptions } from "@tanstack/react-query";
import { createQueryGroup } from "../../core/api/queries";
import { ContractTypeId, OfficeId } from "../../shared/schema/schema";

export default createQueryGroup(({ api }) => {
  return {
    list: () =>
      queryOptions({
        queryKey: ["contract", "contract_types"],
        queryFn: () => api.get("./contract_types", {}),
      }),

    serviceCodeIssuesSettings: (contractTypeId: ContractTypeId, officeId: OfficeId) =>
      queryOptions({
        queryKey: ["contract", contractTypeId, "office", officeId, "service_code_issues_settings"],
        queryFn: () =>
          api.get(
            "/agencies/:agencyId/contractType/:contractTypeId/offices/:officeId/service_code_issues_settings",
            { path: { contractTypeId, officeId } }
          ),
      }),
  };
});
